import { useTranslation } from 'libs/i18n'

import { Header } from 'shared/components'
import {
	DashboardSummaries,
	DashboardAreasList,
	DashboardRecentlyAdded,
	DashboardRecentlySold
} from '../../organisms/'

const DashboardPage = () => {
	const { t } = useTranslation()

	return (
		<>
			<Header title={t('Dashboard')} />
			<div className="space-y-5 px-5 lg:px-0">
				<DashboardSummaries />
				<div className="grid gap-5 xl:grid-cols-[minmax(0,1.55fr)_minmax(300px,0.75fr)]">
					<DashboardAreasList />
					<DashboardRecentlyAdded />
				</div>
				<DashboardRecentlySold />
			</div>
		</>
	)
}

export default DashboardPage
